import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import Button from "@/components/button";
import {
  InputError,
  Form,
  Formik,
  FormikControl,
  useState,
  useEffect,
  Image,
  useRef,
  useRouter,
} from "@/imports-files/common/common";
import {
  SHARE_CV,
  SHARE_CV_VALIDATION_SCHEMA,
} from "@/constants/components/share-cv";
import { ActionShareCv } from "@/actions/components/share-cv";
import { FormModalStyle } from "@/imports-files/components/review-email";
import { Close } from "@/imports-files/components/common-modal/common-modal";

export function ShareCv(props) {
  const [jobTitleOptions, setJobTitleOptions] = useState("");
  const [value, setValue] = useState("");
  const [suggestion, setSuggestion] = useState([]);
  const share_cv_action = new ActionShareCv(setValue, setSuggestion);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedUserCount, setSelectedUserCount] = useState(0);
  const formRef = useRef(null);
  const router = useRouter();

  return props.trigger ? (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => {
              setValue("");
              setSelectedValues([]);
              props.setButtonPopup(false);
            }}
          >
            <Close />
            CLOSE
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
            <div
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              Share CV
            </div>
            <Formik
              initialValues={SHARE_CV}
              validationSchema={SHARE_CV_VALIDATION_SCHEMA}
              innerRef={formRef}
              onSubmit={() => {
                router.asPath.includes("/clients/candidates")
                  ? share_cv_action.submitCandidateShareForm(
                      router,
                      formRef.current,
                      selectedValues,
                      props.setApiError,
                      props.setButtonPopup,
                      setSelectedValues
                    )
                  : share_cv_action.submitJobShareForm(
                      router,
                      formRef.current,
                      selectedValues,
                      props.setApiError,
                      props.setButtonPopup,
                      setSelectedValues
                    );
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                    >
                      Share With *
                    </label>
                    <FormikControl
                      control="autosuggestInput"
                      errorClass={PageStyle.Form__Error}
                      formik={formik}
                      style = {{width: "60%"}}
                      getSuggestionValue={share_cv_action.getSuggestionValue}
                      inputProps={{
                        className: `AutosuggestOpenUp ${PageStyle.Form__Input}`,
                        formik: formik,
                        name: "share_with",
                        onChange: (value, { newValue }) => {
                          formik.touched["share_with"] = true;
                          formik.setStatus({ share_with: "" });
                          setValue(newValue);
                        },
                        placeholder: "Start typing name",
                        style: InputError(formik, `share_with`),
                        value: value,
                      }}
                      onSuggestionsClearRequested={
                        share_cv_action.onSuggestionsClearRequested
                      }
                      onSuggestionsFetchRequested={
                        share_cv_action.onSuggestionsFetchRequested
                      }
                      onSuggestionSelected={(event, { suggestion }) => {
                        if (suggestion.user_attributes.email.length > 0) {
                          setValue("");
                          share_cv_action.onSuggestionSelectionValue(
                            {
                              email: suggestion.user_attributes.email,
                              name_initials:
                                suggestion.user_attributes.name_initials,
                              name: suggestion.user_attributes.name,
                              photo_url: suggestion.user_attributes.photo_url,
                            },
                            selectedValues,
                            setSelectedValues,
                            setValue,
                            setSelectedUserCount,
                            formik
                          );
                        }
                      }}
                      renderSuggestion={share_cv_action.renderSuggestion}
                      shouldRenderSuggestions={
                        share_cv_action.shouldRenderSuggestions
                      }
                      suggestions={suggestion}
                      type="email"
                    />
                  </div>
                  {/* TODO Applied With List */}
                  {selectedValues.map(function (element, index) {
                    return (
                      <div
                        className={`Sharecv ${PageStyle.Tagrow}`}
                        key={index}
                      >
                        <div className={PageStyle.Tagrow__Tags}>
                          {element?.photo_url ? (
                            <img
                              src={element?.photo_url}
                              className="JobImageSmall"
                            />
                          ) : (
                            element.name_initials && (
                              <div className={PageStyle.Tagrow__Prefix}>
                                {element.name_initials}
                              </div>
                            )
                          )}

                          <p className={`ml6`}>
                            {element.name || element.email}
                          </p>
                          <button
                            type="button"
                            className={PageStyle.Tagrow__Cancel}
                            onClick={(event) =>
                              share_cv_action.removeSelectedValues(
                                event,
                                selectedValues,
                                setSelectedValues,
                                setSelectedUserCount
                              )
                            }
                            data-index={index}
                          >
                            <Close/>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                  {/* TODO Applied With List */}

                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                    >
                      Add a Little Note *
                    </label>
                    <FormikControl
                      control="customtextarea"
                      type="text"
                      formik={formik}
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Textarea}`}
                      name="title_note"
                      rows="4"
                      style={InputError(formik, `title_note`)}
                    />
                  </div>
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection} style={{gap: "0"}}
                  >
                    <Button buttonstyle={PageStyle.primarybtn} type="submit">
                      Share
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}
